export default "__VITE_ASSET__OlsX3AUB__"